import getStore from '../store';
import type { NotificationBarHostId } from 'owa-notification-bar';

export default function getNotificationBarHostId(): NotificationBarHostId {
    return getStore().notificationBarHostId;
}
